import React, { useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import store from './../store'
import { removeTrailingSlash } from './../utils/js/shared_helpers'
import { handleError } from 'utils/js/error_helpers'
import useAds from 'context/AdsContext'
import useIsMobile from 'context/IsMobileContext'
import { getParameterByName } from 'utils/js/browser_helpers'
import { isSameGamePage } from 'utils/js/tab_url_helpers'

function RouteListener(props) {
    let { setAds, updateAdTargets } = useAds()
    let { setIsMobileApp, setIsAndroid } = useIsMobile()

    let prevPath = removeTrailingSlash(window.location.pathname)

    useEffect(() => {
        // Stop continuous push of same url into history
        const prevHistoryPush = props.history.push
        props.history.push = (pathname, state = {}) => {
            if (removeTrailingSlash(pathname) !== removeTrailingSlash(prevPath)) {
                prevHistoryPush(removeTrailingSlash(pathname), state)
            }
        }

        // LISTENS FOR EVERY ROUTE CHANGE
        props.history.listen(location => {
            // SNWEB-2205: only the tab/video segments changed within the same game
            // page — keep ads, the live websocket, and game data intact.
            const nextPath = removeTrailingSlash(location.pathname)
            if (nextPath !== prevPath && isSameGamePage(prevPath, nextPath)) {
                prevPath = nextPath
                return
            }
            // eslint-disable-next-line no-undef
            Object.keys(adUtility.slots).forEach(function(a) {
                window.adUtility.destroySlot(a)
                // Some environments apply `collapseDiv:"BEFORE_FETCH"` globally via GPT, which
                // collapses (display:none) the slot div when it becomes empty after destroy.
                // adUtility's processVisibility uses elementInView, which returns false for
                // hidden elements (offsetParent === null), preventing googletag.display() from
                // ever being called and leaving the ads invisible after re-initialization.
                // Reset display here so the div is visible when insertAd re-defines the slot.
                const el = document.getElementById(a)
                if (el) el.style.display = ''
            })

            if (location.pathname === prevPath) return
            prevPath = removeTrailingSlash(location.pathname)

            // if this is a live tracker route (games)
            onLivetrackerRouteChange(location)
            store.dispatch({ type: 'WS_DISCONNECT' }) // disconnect ws connection
            store.dispatch({ type: 'RESET_INIT_VIDEO_FEED_REQUEST' }) // reset initial video request param
        })
        return props.history.unlisten
    }, [])

    // used to check cycles
    const mounted = useRef()

    useEffect(() => {
        if (!mounted.current) {
            // componentDidMount logic
            const load = async () => {
                /*
                 * Live Tracker Route Change
                 * - On initial app load, if this is a live tracker route (games), specify a route change is occuring
                 */
                onLivetrackerRouteChange(window.location)
            }
            load().catch(err => {
                handleError(err)
            })

            mounted.current = true
        }
    })

    let onLivetrackerRouteChange = async location => {
        if (location.pathname) {
            localStorage.setItem('easRedirectUrl', location.href) // keep track of last visited page for EAS login redirect
            let paths = location.pathname.split('/')
            let pageType = paths[3]
            let gameCode = paths[4]

            if (pageType && gameCode && pageType === 'games') {
                store.dispatch({
                    type: 'ROUTE_CHANGE',
                    location: location,
                    id: gameCode,
                })
                // SET ADD
                setAds(0)
            }

            // SET IS MOBILE
            setIsMobileApp(getParameterByName('template') === 'basic')
            setIsAndroid(getParameterByName('platform') === 'android')
        }

        if (!window.location.pathname.includes('/players')) {
            updateAdTargets()
        }
    }

    return <React.Fragment>{props.children}</React.Fragment>
}

export default withRouter(RouteListener)
